import React from "react";
import { Row, Col } from "antd";
import InputComponent from "../InputComponent/InputComponent";
import RadioComponent from "../RadioComponent/RadioComponent";
import DatePickerComponent from "../DatePickerComponent/DatePickerComponent";
import { PaymentLabel, PaymentText, PaymentRemover } from "./styles";
import { LabelWrapper, PaymentDivider } from "../../styles";
import TooltipComponent from "../../../../../../CommonComponents/Info/Tooltip/TooltipComponent";
import { DisplayFlex } from "../../../../../../CommonComponents/commonStyles";
import { GrantPillButton } from "../../styles";
import { CapsuleButton } from "../../../../../../CommonComponents/Commons/commonComponents";

export const removePaymentRender = (index, removePayment) => (
  <CapsuleButton
    onClick={() => removePayment(index)}
    text="Remove payment -"
    id="btnRemovePayment"
  ></CapsuleButton>
);

export const getRadioComponentData = (value, data) => {
  switch (value) {
    case true:
      return data[0];
    case false:
      return data[1];
    default:
      return null;
  }
};

const PaymentForm = ({
  index,
  payment,
  handleBlur,
  disableDate,
  paymentChange,
  dateChange,
  paymentCount,
  radioChange,
  removePayment,
  grantPurposeDropdown,
}) => {
  const intendedPaymentDateMessage = "Please enter intended payment date.";
  const requirementMessage = "Please enter requirement due date.";

  return (
    // don't change classes its used in scroll fun
    <div className={`grant-agreement-payment gaw-payment-${index + 1}`}>
      <PaymentText>Payment {index + 1}</PaymentText>
      <Row>
        <Col lg={{ span: 7 }}>
          <InputComponent
            id={`payamount${index}`}
            placeholder="Enter payment amount"
            ariaLabel="payment-amount"
            role="text"
            name="grantAmountStr"
            maxLength={100}
            value={payment.grantAmountStr}
            labelValue="Payment amount"
            errorLabel={payment.grantAmountStrErr && payment.paymentMessage}
            onChange={(e) => {
              paymentChange(index, e);
            }}
            onBlur={(e) => handleBlur(e, index)}
            fullWidth
          />
        </Col>
        <Col lg={{ span: 7, offset: 1 }}>
          <DatePickerComponent
            id={`payment-date${index}`}
            placeholder="Enter payment date"
            ariaLabel="drop down"
            role="grid"
            disableDate={(e) => disableDate(e, index, "intendedPaymentDate")}
            value={payment.intendedPaymentDate}
            errorLabel={
              payment.intendedPaymentDateErr && intendedPaymentDateMessage
            }
            labelValue="Recommended payment date"
            dateChange={(e) => {
              dateChange(index, "intendedPaymentDate", e);
            }}
          />
        </Col>
      </Row>
      <Row role="radiogroup">
        <Col lg={{ span: 24 }}>
          <RadioComponent
            id={`report-req${index}`}
            radioVal={["Yes", "No"]}
            name="reportRequirement"
            role="radio"
            aria-label="reportRequirement"
            property="Is the organization required to provide grant reporting as a stipulation of accepting the grant?"
            radioChange={(e) => radioChange(index, e)}
            radioValue={getRadioComponentData(payment.reportRequirement, [
              "Yes",
              "No",
            ])}
          />
        </Col>
      </Row>
      <PaymentRemover>
        {!payment.reportRequirement &&
          paymentCount > 1 &&
          removePaymentRender(index, removePayment)}
      </PaymentRemover>
      {payment.reportRequirement && (
        <div>
          <DisplayFlex>
            <LabelWrapper>Requirement Type:</LabelWrapper>
            {grantPurposeDropdown === "Unrestricted Gift" ? (
              <PaymentLabel style={{ marginLeft: "10px" }}>
                Annual report
                <TooltipComponent text="Grant purpose dropdown value is Unrestricted gift" />
              </PaymentLabel>
            ) : (
              <PaymentLabel style={{ marginLeft: "10px" }}>
                {/* As for issue OW-703 Budget changed to budget */}
                Narrative and Project budget
                <TooltipComponent text="Grant purpose dropdown value is others" />
              </PaymentLabel>
            )}
          </DisplayFlex>
          <Row>
            <Col lg={{ span: 8 }}>
              <DatePickerComponent
                placeholder="Select due date"
                aria-label="duedate"
                id={`reportduedate${index}`}
                disableDate={(e) =>
                  disableDate(e, index, "grantRequirementDueDate")
                }
                labelValue="Reporting due date:"
                value={payment.grantRequirementDueDate}
                errorLabel={
                  payment.grantRequirementDueDateErr && requirementMessage
                }
                dateChange={(e) =>
                  dateChange(index, "grantRequirementDueDate", e)
                }
              />
            </Col>
          </Row>
          <Row role="radiogroup">
            <Col lg={{ span: 8 }}>
              <RadioComponent
                id={`contreportreq${index}`}
                name="isContingent"
                role="radio"
                aria-label="isContingent"
                property="Should future payments be contingent on reporting requirements?"
                radioVal={["Yes", "No"]}
                radioChange={(e) => radioChange(index, e)}
                radioValue={getRadioComponentData(payment.isContingent, [
                  "Yes",
                  "No",
                ])}
              />
            </Col>
          </Row>
          <PaymentRemover>
            {paymentCount > 1 && removePaymentRender(index, removePayment)}
          </PaymentRemover>
        </div>
      )}
      {index + 1 < paymentCount && <PaymentDivider />}
    </div>
  );
};

export default PaymentForm;
